
import JdSsr from "@/models/jd-ssr";

export default {
    name: 'JdDetailHeader',
    props: {
        jd: Object,
    },
}
